module.exports = __webpack_public_path__ + "img/Insufficient-lapse.51d02463.png";